import React, { createContext, ReactNode, useEffect, useState } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";

interface SidebarNavContextType {
  isCollapsed: boolean;
  setIsCollapsed: (value: boolean) => void;
  toggleSidebar: () => void;
}

export const SidebarNavContext = createContext<
  SidebarNavContextType | undefined
>(undefined);

export const SidebarNavProvider = ({ children }: { children: ReactNode }) => {
  const [storedCollapsed, setIsCollapsed] = useLocalStorage<boolean>(
    "sidebar-collapsed",
    false,
  );

  const [isDesktopXl, setIsDesktopXl] = useState(() => {
    if (typeof window === "undefined") return true;
    return window.innerWidth >= 1280;
  });

  useEffect(() => {
    const update = () => setIsDesktopXl(window.innerWidth >= 1280);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  // Force expanded on non-xl (tablet/mobile) while keeping persisted state
  const isCollapsed = isDesktopXl ? storedCollapsed : false;
  const toggleSidebar = () => {
    // Only allow toggling on xl and above
    if (isDesktopXl) {
      setIsCollapsed((prev) => !prev);
    }
  };

  return (
    <SidebarNavContext.Provider
      value={{ isCollapsed, setIsCollapsed, toggleSidebar }}
    >
      {children}
    </SidebarNavContext.Provider>
  );
};
